export function normalizeDefinition (def) {
  return {
    actionPipelineCode: def?.actionPipelineCode || '',
    dataPipelineCode: def?.dataPipelineCode || '',
    fieldMapping: def?.fieldMapping || { groups: [] },
    argMapping: def?.argMapping || {},
    invalidations: def?.invalidations || [],
    authScheme: def?.authScheme || null
  }
}
